import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import ReceptaclePodPerformanceReport from '../../components/ReceptaclePodPerformanceReport';
import {
  getColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
} from '../redux/selectors/ReceptaclePodPerformanceSummarySelectors';

export function ReceptaclePodPerformanceSummaryContainer(props) {
  return (
    <ReceptaclePodPerformanceReport
      reportId={ReportDefinitions.RECEPTACLE_POD_PERFORMANCE_404_SUMMARY.id}
      columns={props.columns}
      isLoading={props.isLoading}
      generatedOnDateTime={props.generatedDateTime}
      data={props.data}
    />
  );
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    generatedDateTime: getGeneratedOnDateTime(state),
    isLoading: getIsLoading(state),
    columns: getColumns(state),
  };
}

ReceptaclePodPerformanceSummaryContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.object),
};

export default connect(mapStateToProps)(ReceptaclePodPerformanceSummaryContainer);
